<template>
    <div class="relative bg-black border-b border-gray-700">
        <div class="px-2 mx-auto md:px-6 max-w-7xl">
            <div class="flex items-center text-xs font-normal text-gray-300 justify-left md:justify-between md:space-x-0">
                <!-- Open Mobile Menu -->
                <div class="mr-2 -my-2 md:-mr-2 md:hidden">
                    <button
                        class="inline-flex items-center justify-center p-2 text-gray-400 rounded-md hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500"
                        @click="mobileMenuOpen = !mobileMenuOpen"
                    >
                        <span
                            v-if="!mobileMenuOpen"
                            class="sr-only"
                        >Open menu</span>
                        <MenuIcon
                            v-if="!mobileMenuOpen"
                            aria-hidden="true"
                            class="w-6 h-6"
                        />

                        <span
                            v-if="mobileMenuOpen"
                            class="sr-only"
                        >Close menu</span>
                        <XIcon
                            v-if="mobileMenuOpen"
                            aria-hidden="true"
                            class="w-6 h-6"
                        />
                    </button>
                </div>

                <!-- Home -->
                <div class="inline-flex justify-center flex-grow py-0 md:justify-start">
                    <router-link
                        class="flex items-center px-2 py-2 -ml-2 text-gray-300 rounded lg:px-5 lg:-ml-5 hover:text-white hover:bg-gray-900"
                        to="/"
                    >
                        <span class="sr-only">Visual Design Cafe Home</span>
                        <img
                            alt=""
                            class="w-auto h-6 mr-4 lg:mr-5 lg:border-none lg:pr-0"
                            src="./../assets/logo.png"
                        >
                        <span class="inline whitespace-nowrap">Visual Design Cafe</span>
                    </router-link>
                </div>

                <!-- Desktop Menu -->
                <nav class="hidden md:flex md:flex-grow">
                    <!-- Group Menu -->
                    <div
                        class=" md:flex md:flex-grow"
                    >
                        <Popover
                            v-for="(menuItem, index) in menuGroup"
                            :key="index"
                            v-slot="{ open }"
                            :class="minimal ? 'hidden' : ''"
                        >
                            <div
                                v-if="!menuItem.featuredProductCards"
                            >
                                <BaseButton
                                    :href="menuItem.href"
                                    :target="menuItem.target"
                                    :to="menuItem.routerLink"
                                    variant="menu"
                                >
                                    {{ menuItem.name }}
                                    <span
                                        v-if="$route.path.includes(menuItem.routerLink)"
                                        class="absolute left-0 h-0.5 -bottom-2 w-full overflow-hidden"
                                    >
                                        <span class="absolute top-0 left-0 w-full h-1 bg-white rounded-full" />
                                    </span>
                                </BaseButton>
                            </div>

                            <PopoverButton
                                v-if="menuItem.featuredProductCards"
                                :class="open ? '' : 'text-opacity-90'"
                                class="inline-flex items-center px-3 py-2 group hover:text-opacity-100 hover:bg-gray-700 hover:rounded hover:text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75"
                            >
                                <span>{{ menuItem.name }}</span>
                                <ChevronDownIcon
                                    :class="[open ? 'transform -rotate-180' : '', 'w-4 h-4 transition-all']"
                                    aria-hidden="true"
                                    class="w-4 h-4 ml-2 transition duration-150 ease-in-out group-hover:text-opacity-80"
                                />
                            </PopoverButton>

                            <div
                                :class="open? 'fixed inset-x-0 bottom-0 z-10 bg-black bg-opacity-30 top-10' : 'hidden'"
                            />

                            <transition
                                enter-active-class="transition duration-100 ease-out"
                                enter-from-class="translate-y-1 opacity-0"
                                enter-to-class="translate-y-0 opacity-100"
                                leave-active-class="transition duration-150 ease-in"
                                leave-from-class="translate-y-0 opacity-100"
                                leave-to-class="translate-y-1 opacity-0"
                            >
                                <PopoverPanel
                                    v-slot="{ close }"
                                    class="absolute z-20 max-w-full w-full mt-2.5 transform -translate-x-1/2 left-1/2 foldout"
                                >
                                    <div
                                        class="sticky overflow-hidden bg-gray-900 border-b border-gray-800 shadow-lg"
                                    >
                                        <div
                                            :class="menuItem.style"
                                            class="relative grid mx-auto border-l border-r border-gray-800 border-dashed divide-gray-800 md:divide-x md:divide-dashed"
                                        >
                                            <router-link
                                                v-for="(card, key) in menuItem.featuredProductCards"
                                                :key="key"
                                                :to="card.to"
                                                class="relative flex flex-col justify-between col-span-1 gap-2 p-4 overflow-visible group"
                                                @click="accept(close)"
                                            >
                                                <div class="absolute transition-transform duration-75 ease-out scale-95 bg-gray-800 bg-opacity-100 rounded opacity-0 -inset-px group-hover:scale-100 group-hover:opacity-100" />
                                                <div class="flex flex-col gap-2">
                                                    <img
                                                        :src="card.image"
                                                        class="relative object-cover w-full rounded shadow-md h-28 group-hover:drop-shadow-lg"
                                                    >
                                                    <div class="flex justify-between">
                                                        <h2 class="relative pl-4 -ml-4 font-semibold text-white group-hover:underline">
                                                            {{ card.title }}
                                                        </h2>
                                                        <p
                                                            class="relative text-purple-400 group-hover:text-purple-300"
                                                        >
                                                            {{ card.type }}
                                                        </p>
                                                    </div>
                                                    <p class="relative p-0">
                                                        {{ card.content }}
                                                    </p>
                                                </div>
                                            </router-link>
                                            <div />
                                        </div>
                                    </div>
                                </PopoverPanel>
                            </transition>
                        </Popover>
                    </div>
                    <!-- Menu simple -->
                    <div class="md:flex">
                        <div
                            v-for="item in menuSimple"
                            :key="item.name"
                            :class="minimal ? 'hidden' : ''"
                            class=" md:mx-auto lg:mx-auto"
                        >
                            <BaseButton
                                :href="item.href"
                                :target="item.target"
                                :to="item.routerLink"
                                variant="menu"
                            >
                                {{ item.name }}
                                <OpenInNewIcon
                                    v-if="item.target == '_blank'"
                                    :size="'1.2em'"
                                    class="inline-block ml-0 align-middle transform -translate-y-px"
                                />

                                <span
                                    v-if="$route.path.includes(item.routerLink)"
                                    class="absolute left-0 h-0.5 -bottom-2 w-full overflow-hidden"
                                >
                                    <span class="absolute top-0 left-0 w-full h-1 bg-white rounded-full" />
                                </span>
                            </BaseButton>
                        </div>
                    </div>
                </nav>

                <!-- Account -->
                <div class="inline-flex">
                    <transition
                        enter-active-class="transition duration-100 ease-out"
                        enter-from-class="transform opacity-0"
                        enter-to-class="transform opacity-100"
                        leave-active-class="transition duration-75 ease-in"
                        leave-from-class="transform opacity-100"
                        leave-to-class="transform opacity-0"
                    >
                        <div
                            v-if="accountMenuOpen"
                            class="fixed top-0 left-0 z-20 w-full h-screen bg-black opacity-50"
                            @click="accountMenuOpen = false"
                        />
                    </transition>
                    <div class="relative z-30">
                        <!-- Account Button -->
                        <div class="inline-block py-1">
                            <BaseButton
                                variant="menu"
                                @click="accountMenuOpen = !accountMenuOpen"
                            >
                                <span
                                    v-if="isSignedIn"
                                    class="relative inline-flex items-center justify-center w-6 h-6 overflow-hidden bg-purple-500 rounded-full"
                                >
                                    <span class="ml-0.5 text-xs font-medium leading-none text-white">{{
                                        userInitials
                                    }}</span>
                                    <img
                                        v-if="userPicture"
                                        :src="userPicture"
                                        class="absolute inset-0"
                                    >
                                </span>
                                <svg
                                    v-if="!isSignedIn"
                                    class="inline-block w-6 h-6"
                                    fill="currentColor"
                                    viewBox="0 0 20 20"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        clip-rule="evenodd"
                                        d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-6-3a2 2 0 11-4 0 2 2 0 014 0zm-2 4a5 5 0 00-4.546 2.916A5.986 5.986 0 0010 16a5.986 5.986 0 004.546-2.084A5 5 0 0010 11z"
                                        fill-rule="evenodd"
                                    />
                                </svg>
                            </BaseButton>
                        </div>

                        <!-- Account Popup -->
                        <transition
                            enter-active-class="transition duration-100 ease-out"
                            enter-from-class="transform scale-95 opacity-0"
                            enter-to-class="transform scale-100 opacity-100"
                            leave-active-class="transition duration-75 ease-in"
                            leave-from-class="transform scale-100 opacity-100"
                            leave-to-class="transform scale-95 opacity-0"
                        >
                            <div
                                v-if="accountMenuOpen"
                                class="absolute top-0 z-20 mt-12 overflow-hidden bg-white rounded-md shadow-xl right-2 whitespace-nowrap"
                            >
                                <!-- Name + Email -->
                                <div class="px-4 py-3 bg-gray-100">
                                    <p
                                        v-if="isSignedIn"
                                        class="text-xs text-gray-400"
                                    >
                                        Signed in as
                                    </p>
                                    <p
                                        v-else
                                        class="text-xs text-gray-400"
                                    >
                                        You are not signed in
                                    </p>
                                    <p
                                        v-if="isSignedIn"
                                        class="mt-1 text-sm font-medium text-gray-900 truncate"
                                    >
                                        {{ userFullName }}
                                    </p>
                                    <p
                                        v-if="isSignedIn"
                                        class="mt-0 text-xs font-medium text-gray-500 truncate"
                                    >
                                        {{ userEmail }}
                                    </p>
                                    <p
                                        v-if="isSignedIn && !userIsVerified"
                                        class="mt-2"
                                    >
                                        <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-800">
                                            Email Not Verified
                                        </span>
                                    </p>
                                </div>

                                <!-- Links -->
                                <div
                                    v-if="isSignedIn"
                                    class="flex flex-col gap-2 px-1 py-1"
                                >
                                    <router-link
                                        :to="{ name: 'Downloads' }"
                                        class="inline-flex w-full px-2 py-2 text-sm text-left text-gray-700 rounded-md hover:text-purple-600 hover:bg-gray-100"
                                    >
                                        <DownloadIcon
                                            aria-hidden="true"
                                            class="w-5 h-5 mr-4 opacity-75"
                                        />
                                        Downloads
                                    </router-link>
                                    <router-link
                                        :to="{ name: 'Account' }"
                                        class="inline-flex w-full px-2 py-2 text-sm text-left text-gray-700 rounded-md hover:text-purple-600 hover:bg-gray-100"
                                    >
                                        <UserCircleIcon
                                            aria-hidden="true"
                                            class="w-5 h-5 mr-4 opacity-75"
                                        />
                                        Account
                                    </router-link>
                                    <router-link
                                        :to="{ name: 'Licenses' }"
                                        class="inline-flex w-full px-2 py-2 text-sm text-left text-gray-700 rounded-md hover:text-purple-600 hover:bg-gray-100"
                                    >
                                        <KeyIcon
                                            aria-hidden="true"
                                            class="w-5 h-5 mr-4 opacity-75"
                                        />
                                        Licenses
                                    </router-link>
                                </div>

                                <!-- Sign In/Sign Out -->
                                <div class="flex flex-col gap-2 px-1 py-1">
                                    <button
                                        v-if="isSignedIn"
                                        class="inline-flex w-full px-2 py-2 text-sm text-left text-gray-700 rounded-md hover:text-purple-600 hover:bg-gray-100"
                                        @click="onLogoutClicked"
                                    >
                                        <ArrowCircleLeftIcon
                                            aria-hidden="true"
                                            class="w-5 h-5 mr-4 opacity-75"
                                        />
                                        Sign out
                                    </button>
                                    <button
                                        v-else
                                        class="inline-flex w-full px-4 py-2 text-sm text-left text-gray-700 rounded-md hover:text-purple-600 hover:bg-gray-100"
                                        @click="onLoginClicked"
                                    >
                                        <ArrowCircleRightIcon
                                            aria-hidden="true"
                                            class="w-5 h-5 mr-4 opacity-75"
                                        />
                                        Sign in
                                    </button>
                                </div>
                            </div>
                        </transition>
                    </div>
                </div>
            </div>
        </div>

        <!-- Mobile Menu -->
        <transition
            enter-active-class="duration-200 ease-out"
            enter-from-class="opacity-0"
            enter-to-class="opacity-100"
            leave-active-class="duration-100 ease-in"
            leave-from-class="opacity-100"
            leave-to-class="opacity-0"
        >
            <div
                v-if="mobileMenuOpen"
                class="relative inset-x-0 px-2 pb-4 transition origin-top transform top-2 md:hidden"
                focus
            >
                <nav class="grid gap-y-4 justify-items-start">
                    <BaseButton
                        v-for="item in menu"
                        :key="item.name"
                        :href="item.href"
                        :target="item.target"
                        variant="menu"
                        @click="onMobileLinkClicked(item.routerLink)"
                    >
                        {{ item.name }}
                        <span
                            v-if="item.new"
                            class="p-1 rounded ml-2 py-0.5 text-green-100 bg-green-700"
                        >
                            New
                        </span>
                    </BaseButton>
                </nav>
            </div>
        </transition>
    </div>
</template>

<script lang="ts" setup>
import {
    ArrowCircleLeftIcon,
    ArrowCircleRightIcon,
    DownloadIcon,
    KeyIcon,
    MenuIcon,
    UserCircleIcon,
    XIcon
} from "@heroicons/vue/outline";
import BaseButton from "../../common/components/BaseButton.vue";
import { computed, inject, ref } from "vue";
import { useRouter } from "vue-router";
import { store } from "./../services/store";
import { Auth, signOut, User } from "firebase/auth";
import OpenInNewIcon from "vue-material-design-icons/OpenInNew.vue";
import { Popover, PopoverButton, PopoverPanel } from "@headlessui/vue";
import { ChevronDownIcon } from "@heroicons/vue/solid";
import NatureRendererCard from "./../assets/nature-renderer-card.jpg";
import NatureShadersCard from "./../assets/nature-shaders-card.jpg";
import RealisticMeadowCard from "./../assets/realistic-meadow-card.jpg";
import StylizedNatureFeatured from "./../assets/stylized-nature-1.jpg";

const menuGroup = [
    {
        name: "Learn",
        routerLink: "/learn/",
        active: false,
        new: false
    },
    {
        name: "Create",
        style: "grid-cols-2 lg:max-w-lg max-w-lg",
        featuredProductCards: [
            {
                title: "Realistic Nature",
                type: "3D Models",
                content: "Create realistic worlds with these photo-scanned vegetation assets.",
                image: RealisticMeadowCard,
                to: "/realistic-nature/"
            },
            {
                title: "Stylized Nature",
                type: "3D Models",
                content: "Hand-crafted assets to bring your worlds to life.",
                image: StylizedNatureFeatured,
                to: "/stylized-nature/"
            }
        ]
    },
    {
        name: "Render",
        style: "grid-cols-2 lg:max-w-lg max-w-lg",
        featuredProductCards: [
            {
                title: "Nature Renderer",
                type: "Plugin",
                content: "Render vast amounts of vegetation on your terrain",
                image: NatureRendererCard,
                to: "/nature-renderer/"
            },
            {
                title: "Nature Shaders",
                type: "Shader",
                content: "Wind effects, interaction and better shading for your vegetation.",
                image: NatureShadersCard,
                to: "/nature-shaders/"
            }
        ]
    }
];

const menuSimple = [
    {
        name: "Docs",
        routerLink: "/docs/",
        active: false,
        new: false
    },
    {
        name: "Support",
        routerLink: "/support/",
        active: false,
        new: false
    }
];

const menu = [
    {
        name: "Learn",
        routerLink: "/learn",
        active: false,
        new: false
    },
    {
        name: "Nature Renderer",
        routerLink: "/nature-renderer",
        active: false,
        new: false
    },
    {
        name: "Nature Shaders",
        routerLink: "/nature-shaders",
        active: false,
        new: false
    },
    {
        name: "Realistic Nature",
        routerLink: "/realistic-nature",
        active: false,
        new: true
    },
    {
        name: "Stylized Nature",
        routerLink: "/stylized-nature",
        active: false,
        new: false
    },
    {
        name: "Docs",
        routerLink: "/docs",
        active: false,
        new: false
    },
    {
        name: "Support",
        routerLink: "/support",
        active: false,
        new: false
    }
];

const props = defineProps({
    minimal: Boolean
});

const firebaseAuth: Auth = inject("firebaseAuth");
const router = useRouter();

const accountMenuOpen = ref(false);
const mobileMenuOpen = ref(false);

/**
 * Computes if the user is currently signed in.
 */
const isSignedIn = computed(() =>
{
    return store.getters.user;
});

const userPicture = computed(() =>
{
    return store.getters.user?.photoURL;
});

/**
 * Computes the initials of the user's name, if the user
 * is signed in. For example: "Max Plooi" => "MP"
 */
const userInitials = computed(() =>
{
    const user: User = store.getters.user;
    if (user)
    {
        const fullName = user.displayName;
        if (fullName)

            return fullName.split(" ").map((n) => n[0]).join("").toUpperCase();

        else

            return user.email[0].toUpperCase();
    }
    else
    {
        return "";
    }
});

const userIsVerified = computed(() =>
{
    const user: User = store.getters.user;
    return user?.emailVerified;
});

/**
 * Computes the user's email address, if the user is signed in.
 */
const userEmail = computed(() =>
{
    const user = store.getters.user;
    return user ? user.email : "";
});

/**
 * Computes the user's full name, if the user is signed in.
 */
const userFullName = computed(() =>
{
    const user = store.getters.user;
    return user ? user.displayName : "";
});

function onMobileLinkClicked (to: any)
{
    mobileMenuOpen.value = false;
    router.push(to);
}

function onLoginClicked ()
{
    router.push({ name: "Login", query: { url: router.currentRoute.value.fullPath } });
}

function onLogoutClicked ()
{
    signOut(firebaseAuth).finally(() =>
    {
        accountMenuOpen.value = false;
    });
}

async function accept (close: any)
{
    close();
    // Enable scrolling when clicking on the card
    window.onscroll = null;
}

window.onclick = function ()
{
    sleep(200).then(() =>
    {
        const foldout = document.getElementsByClassName("foldout");
        if (foldout.length != 0)
        {
            window.onscroll = function ()
            {
                window.scrollTo(0, 0);
            };
        }
        else
        {
            window.onscroll = null;
        }
    });
};

const sleep = (milliseconds: number) =>
{
    return new Promise(resolve => setTimeout(resolve, milliseconds));
};

</script>
